/**
 * PeopleInvolvedSection - Extracted component for people involved in incident
 */

import React from 'react';
import Dropdown from '../../../../common/Dropdown';

const PeopleInvolvedSection = ({ formData, handleInputChange, handlePersonToggle, crew, errors }) => (
  <div className="bg-white shadow rounded-lg p-6">
    <h2 className="text-lg font-medium text-gray-900 mb-4">
      People Involved
    </h2>
    
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Reported By <span className="text-red-500">*</span>
        </label>
        <Dropdown
          value={formData.reportedBy}
          onChange={(val) => handleInputChange('reportedBy', val)}
          options={crew.map(member => ({
            value: member.id,
            label: `${member.name} - ${member.position}`
          }))}
          placeholder="Select crew member..."
          width="w-full"
          error={!!errors.reportedBy}
        />
        {errors.reportedBy && (
          <p className="mt-1 text-sm text-red-600">{errors.reportedBy}</p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Persons Directly Involved
          </label>
          <div className="border border-gray-300 rounded-md p-3 max-h-32 overflow-y-auto">
            {crew.map(member => (
              <label key={member.id} className="flex items-center space-x-3 mb-2 cursor-pointer hover:bg-gray-50 p-1 rounded">
                <input
                  type="checkbox"
                  checked={formData.personsInvolved.includes(member.id)}
                  onChange={() => handlePersonToggle(member.id, 'personsInvolved')}
                  className="h-4 w-4 text-cyan-600 focus:ring-cyan-500 border-gray-300 rounded"
                />
                <span className="text-sm text-gray-700">
                  {member.name} - {member.position}
                </span>
              </label>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Witnesses
          </label>
          <div className="border border-gray-300 rounded-md p-3 max-h-32 overflow-y-auto">
            {crew.map(member => (
              <label key={member.id} className="flex items-center space-x-3 mb-2 cursor-pointer hover:bg-gray-50 p-1 rounded">
                <input
                  type="checkbox"
                  checked={formData.witnesses.includes(member.id)}
                  onChange={() => handlePersonToggle(member.id, 'witnesses')}
                  className="h-4 w-4 text-cyan-600 focus:ring-cyan-500 border-gray-300 rounded"
                />
                <span className="text-sm text-gray-700">
                  {member.name} - {member.position}
                </span>
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PeopleInvolvedSection;